import _extends from "@babel/runtime/helpers/esm/extends";
import dayJSLocale from 'dayjs/locale/en';
export var getLocale = function getLocale() {
  return _extends({
    nextMonth: 'Next month',
    previousMonth: 'Previous month'
  }, dayJSLocale);
};